import { configureStore } from "@reduxjs/toolkit";
import selectedPlaceReducer from "./slices/selectedPlaceSlice";
import placeFilterReducer from "./slices/placeFilterSlice";
import notificationReducer from "./slices/notificationSlice";

export const store = configureStore({
  reducer: {
    selectedPlace: selectedPlaceReducer,
    placeFilter: placeFilterReducer,
    notification: notificationReducer,
    // ... other reducers
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
